"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _TableFooter.default;
  }
});

var _TableFooter = _interopRequireDefault(require("./TableFooter"));


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/TableFooter/index.js
// module id = 677
// module chunks = 0